"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwComboBox = _interopRequireDefault(require("./CwComboBox.scss"));

var _CwDropdown = _interopRequireDefault(require("../cwdropdown/CwDropdown"));

var _CwTriggerField = _interopRequireDefault(require("../cwtriggerfield/CwTriggerField"));

var _CwDropdownService = require("../../utils/CwDropdownService");

var _CwThemeService = require("../../utils/CwThemeService");

var _ValidationUtils = require("../../utils/ValidationUtils");

var _ChangeCheck = _interopRequireDefault(require("../../utils/ChangeCheck"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/**
 * Based on react-autocomplete:
 * https://github.com/reactjs/react-autocomplete
 */


var CwComboBox =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwComboBox, _React$Component);

  function CwComboBox(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CwComboBox);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwComboBox).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isValueIncomplete", function () {
      var valueText = _this.props.value ? _this.props.value.name : '';
      return valueText !== _this.state.displayText;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnPicker", function () {
      if (_this.props.onPicker && !_this.props.disabled) {
        var pickerText = _this.isValueIncomplete() ? _this.state.displayText : '';

        _this.props.onPicker(pickerText);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "highlightItemFromMouse", function (index) {
      _this.setState({
        highlightedIndex: index
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectItem", function (item) {
      if (item.id === -1) {
        // Picker selected
        _this.setState({
          expanded: false,
          prevExpanded: true,
          highlightedIndex: null
        });

        _this.handleOnPicker();
      } else if (item.id === null) {
        _this.setState({
          displayText: _this.props.nullOptionName,
          expanded: false,
          prevExpanded: true,
          highlightedIndex: null
        });

        if (_this.props.onChange) {
          _this.props.onChange(null);
        }
      } else {
        var displayText = item.name;
        var value = _this.props.returnIdAsValue ? item.id : _objectSpread({}, item);

        _this.setState({
          displayText: displayText,
          expanded: false,
          prevExpanded: true,
          highlightedIndex: null
        });

        if (_this.props.onChange) {
          // Report value of item selected if it changed
          if (_this.props.customItemName || _this.props.value === null || value.id !== _this.props.value.id || _this.props.returnIdAsValue && value !== _this.props.value) {
            //remove the leftwidget from shape being passed up the chain so that Database does not complain. Should not affect boxes without leftwidget
            delete value.leftWidget;

            _this.props.onChange(value);
          }
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectItemFromMouse", function (item) {
      _this.selectItem(item);

      _this.focus();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectItemFromKeyDown", function (event) {
      if (_this.state.expanded === false) {// Menu is closed so there is no selection to accept: do nothing
      } else if (_this.state.highlightedIndex === -1) {
        // Picker selected
        _this.setState({
          expanded: false,
          prevExpanded: true,
          highlightedIndex: null
        });

        _this.handleOnPicker();
      } else if (_this.state.highlightedIndex === null) {
        // Input has focus but no menu item is matched and Enter is hit
        if (_this.props.allowCustomEntry) {
          // If custom entry allowed
          var displayText = _this.state.displayText;
          var value = _this.state.displayText;

          _this.setState({
            displayText: displayText,
            expanded: false,
            prevExpanded: true,
            highlightedIndex: null
          });

          if (_this.props.onChange) {
            _this.props.onChange(value); // Report the custom value

          }
        } else {
          // If custom entry not allowed
          _this.setState({
            displayText: _this.props.nullOptionName,
            // Blank out display text
            expanded: false,
            prevExpanded: true
          });

          if (_this.props.onChange) {
            _this.props.onChange(null); // Report value of null

          }
        }
      } else {
        // Menu item is matched, so select it
        event.preventDefault();

        var itemList = _this.getItemsWithPriorityList();

        var item = _this._triggerClicked ? itemList[_this.state.highlightedIndex] : _this.getFilteredItems(itemList)[_this.state.highlightedIndex];

        _this.selectItem(item);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setIgnoreBlur", function (ignore) {
      _this._ignoreBlur = ignore;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleScroll", function (event) {
      // Hide dropdown when window is scrolled
      if (_this.state.expanded && (event.target === document || !event.target.className.includes('CwDropdown-dropDown'))) {
        _this.setState({
          expanded: false,
          prevExpanded: true
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyDown", function (event) {
      _this._typing = true;

      if (_this.keyDownHandlers[event.key]) {
        _this.keyDownHandlers[event.key].call((0, _assertThisInitialized2.default)(_this), event);
      } else {
        _this._triggerClicked = false;
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyUp", function () {
      if (_this._performAutoCompleteOnKeyUp) {
        _this._performAutoCompleteOnKeyUp = false;

        _this.autoCompleteText();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (enteredText) {
      _this._performAutoCompleteOnKeyUp = true;

      _this.setState({
        displayText: enteredText,
        expanded: true,
        prevExpanded: false,
        filter: true
      });

      if (enteredText === '') {
        _this.setState({
          highlightedIndex: null
        });
      }

      if (_this.props.textChange) {
        _this.props.textChange(enteredText);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleInputBlur", function () {
      _this._typing = false;
      _this._triggerClicked = false;
      if (_this._ignoreBlur) return; // IE fires a blur event when clicking the scrollbar - this prevents the dropdown from closing

      if (_this.cwDropdown && _this.cwDropdown.isMousedOver()) {
        _this.cwTriggerField.focus();

        return;
      } // Clear out invalid entries


      if (!_this.props.pickerText && !_this.props.allowCustomEntry) {
        // Don't clear out pickers as they can have values that aren't in the dropdown
        var filteredItems = _this.props.items.filter(function (item) {
          return item.name === _this.state.displayText;
        });

        if (_this.props.items.length > 0) {
          // Only check if items have been loaded
          if (filteredItems.length === 0) {
            _this.setState({
              displayText: _this.props.nullOptionName
            }); // Check if we were previously empty, if we are we don't need to dirty the flag.


            if (!(0, _ValidationUtils.IsEmpty)(_this.props.value)) {
              // We weren't empty so send null back to blank out he field.
              if (_this.props.onChange) {
                _this.props.onChange(null); // Clear out if no matches in dropdown

              }
            }
          } else {
            // If valid, select the item
            _this.selectItem(filteredItems[0]);
          }
        } else if (_this.props.items.length === 0) {
          // If items don't exist yet and the value has changed, blank out the field
          var hasChanged = (0, _ValidationUtils.IsEmpty)(_this.props.value) ? !(0, _ValidationUtils.IsEmpty)(_this.state.displayText) : _this.props.value.name !== _this.state.displayText;

          if (hasChanged) {
            _this.setState({
              displayText: _this.props.nullOptionName
            });

            if (!(0, _ValidationUtils.IsEmpty)(_this.props.value)) {
              if (_this.props.onChange) {
                _this.props.onChange(null);
              }
            }
          }
        }
      } // Text blanked out, so null out value unless, prop to allowEmptyNames
      else if (_this.state.displayText === '' && !_this.props.allowEmptyName) {
          if (!(0, _ValidationUtils.IsEmpty)(_this.props.value)) {
            if (_this.props.onChange) {
              _this.props.onChange(null);
            }
          }
        }

      _this.setState({
        highlightedIndex: null,
        expanded: false,
        prevExpanded: true
      });

      if (_this.props.onBlur) {
        _this.props.onBlur();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleInputFocus", function () {
      if (_this.props.selectAllOnFocus) {
        _this.cwTriggerField.cwTextField.inputField.select();
      }

      if (_this._ignoreBlur) {
        _this.setIgnoreBlur(false);

        return;
      }

      if (_this.props.onFocus) {
        _this.props.onFocus();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTriggerClick", function () {
      // Expand the full unfiltered dropdown if the trigger is clicked
      if (_this.props.disabled) return;

      _this.focus();

      _this.setState({
        expanded: true,
        prevExpanded: false,
        filter: false
      });

      _this._triggerClicked = true;
    });
    _this._typing = false;
    _this._ignoreBlur = false;
    _this._performAutoCompleteOnUpdate = false;
    _this._performAutoCompleteOnKeyUp = false;
    _this._triggerClicked = false;
    _this.state = {
      displayText: _this.props.nullOptionName,
      expanded: false,
      prevExpanded: true,
      highlightedIndex: null,
      filter: true
    };
    _this.keyDownHandlers = {
      ArrowDown: function ArrowDown(event) {
        // Cycle through list of items on arrow down, updating `highlightedIndex` along the way
        event.preventDefault(); // Prevent window scrolling

        var itemList = this.getItemsWithPriorityList();
        var itemsLength = this._triggerClicked ? itemList.length : this.getFilteredItems(itemList).length;
        if (!itemsLength) return;
        var highlightedIndex = this.state.highlightedIndex;
        var topIndex = this.props.pickerText ? -1 : 0;
        var index = highlightedIndex === null || highlightedIndex === itemsLength - 1 ? topIndex : highlightedIndex + 1; // Go back to the top when reaching the end

        this._performAutoCompleteOnKeyUp = true;
        this.setState({
          highlightedIndex: index,
          expanded: true,
          prevExpanded: false,
          filter: this._triggerClicked ? false : true
        });
      },
      ArrowUp: function ArrowUp(event) {
        // Cycle through list of items on arrow up, updating `highlightedIndex` along the way
        event.preventDefault(); // Prevent window scrolling

        var itemList = this.getItemsWithPriorityList();
        var itemsLength = this._triggerClicked ? itemList.length : this.getFilteredItems(itemList).length;
        if (!itemsLength) return;
        var highlightedIndex = this.state.highlightedIndex;
        var topIndex = this.props.pickerText ? -1 : 0;
        var index = highlightedIndex === topIndex || highlightedIndex === null ? itemsLength - 1 : highlightedIndex - 1; // Go back to the end when reaching the top

        this._performAutoCompleteOnKeyUp = true;
        this.setState({
          highlightedIndex: index,
          expanded: true,
          prevExpanded: false,
          filter: this._triggerClicked ? false : true
        });
      },
      // Update value on shortcut keydown
      Alt: function Alt(event) {
        this.selectItemFromKeyDown(event);
      },
      Control: function Control(event) {
        this.selectItemFromKeyDown(event);
      },
      Meta: function Meta(event) {
        this.selectItemFromKeyDown(event);
      },
      Tab: function Tab(event) {
        if (this.props.onPicker && this.state.highlightedIndex === null && this.isValueIncomplete()) {
          this.handleOnPicker();
        } else {
          this.selectItemFromKeyDown(event);
        }
      },
      Enter: function Enter(event) {
        this._typing = false;

        if (this.props.onPicker && this.state.highlightedIndex === null) {
          this.handleOnPicker();
        } else if (this.props.enterSelectsFirstItem && this.state.highlightedIndex === null) {
          this.setState({
            highlightedIndex: 0 // Select first item if prop is enabled

          });
        } else {
          this.selectItemFromKeyDown(event);
        }
      },
      Escape: function Escape() {
        this.setState({
          highlightedIndex: null,
          expanded: false,
          prevExpanded: true
        });
      }
    };
    _this.handleTriggerFieldClick = _this.handleTriggerFieldClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CwComboBox, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.customItemName) {
        return true;
      }

      var propsToCheck = ['value', 'disabled', 'invalid', 'items', 'readOnly'];
      var stateToCheck = ['displayText', 'expanded', 'highlightedIndex', 'filter'];
      return (0, _ChangeCheck.default)(propsToCheck, this.props, nextProps) || (0, _ChangeCheck.default)(stateToCheck, this.state, nextState) || this.state.prevExpanded !== nextState.expanded;
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      window.addEventListener('scroll', this.handleScroll, true);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this; // Display value's name if already given one when combobox re-mounts (i.e. after pod collapses then re-expands)


      if (this.props.value && (this.props.value.name || this.props.allowEmptyName && this.props.value.name === '')) {
        this.setState({
          displayText: this.props.value.name
        });
      } else if (this.props.value !== '' && this.props.returnIdAsValue) {
        var items = this.props.items;
        items.forEach(function (item) {
          if (item.id === _this2.props.value) {
            _this2.setState({
              displayText: item.name
            });
          }
        });
      } else if (this.props.value) {
        this.setState({
          displayText: this.props.value
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll, true);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this._performAutoCompleteOnUpdate = true; // If `items` has changed we want to reset `highlightedIndex` since it probably no longer refers to a relevant item

      if (this.props.items !== nextProps.items || // The entries in `items` may have been changed even though the object reference remains the same, double check by seeing if `highlightedIndex` points to an existing item
      this.state.highlightedIndex >= nextProps.items.length) {
        this.setState({
          highlightedIndex: null
        });
      } // Display value's name if receiving it from the parent and user not currently typing in it


      if (nextProps.value && nextProps.value.name !== undefined && this._typing === false) {
        this.setState({
          displayText: nextProps.value.name
        });
      } else if (nextProps.value !== '' && this.props.returnIdAsValue) {
        var items = nextProps.items;
        items.forEach(function (item) {
          if (item.id === nextProps.value) {
            _this3.setState({
              displayText: item.name
            });
          }
        });
      } else if (!nextProps.value && this._typing === false) {
        this.setState({
          displayText: this.props.nullOptionName
        });
      }

      if (this.props.onComponentWillReceiveProps) {
        this.props.onComponentWillReceiveProps(nextProps);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.expanded === true && prevState.expanded === false) {
        var menuPositions = (0, _CwDropdownService.setMenuPositions)(this.cwTriggerField.cwTextField.inputField);
        this.setState({
          menuTop: menuPositions.menuTop,
          menuLeft: menuPositions.menuLeft,
          menuWidth: menuPositions.menuWidth,
          inputHeight: menuPositions.inputHeight
        });
      }

      if (this.state.expanded && this._performAutoCompleteOnUpdate) {
        this._performAutoCompleteOnUpdate = false;
        this.autoCompleteText();
      }

      if (prevState.expanded !== this.state.expanded) {
        if (this.state.expanded) {
          if (this.props.onExpand) this.props.onExpand(this.state.expanded);
        } else {
          if (this.props.onCollapse) this.props.onCollapse(this.state.expanded);
        }
      }
    }
  }, {
    key: "shouldItemRender",
    value: function shouldItemRender(item, enteredText) {
      if (this.props.filterOnPartialMatch) {
        // Only render items that partially match the typed text
        return item.name.toLowerCase().indexOf(typeof enteredText === 'string' ? enteredText.toLowerCase() : '') > -1;
      } else {
        // Only render items that match up to what has been typed
        return item.name.toLowerCase().indexOf(typeof enteredText === 'string' ? enteredText.toLowerCase() : '') === 0;
      }
    }
  }, {
    key: "getItemsWithPriorityList",
    value: function getItemsWithPriorityList() {
      var items = [];

      if (this.props.priorityList.length > 0) {
        items = this.getPriorityList();
        items = items.concat(this.props.items);
      } else {
        items = this.getItems();
      }

      return items;
    }
  }, {
    key: "getItems",
    value: function getItems() {
      var items = this.props.items.slice(0);

      if (this.props.hasNullOption === true && this.props.priorityList.length === 0) {
        items.unshift({
          id: null,
          name: this.props.nullOptionName,
          leftWidget: this.props.nullOptionLeftWidget
        });
      }

      return items;
    }
  }, {
    key: "getPriorityList",
    value: function getPriorityList() {
      var items = this.props.priorityList.slice(0);

      if (this.props.hasNullOption === true && items.length > 0) {
        items.unshift({
          id: null,
          name: this.props.nullOptionName,
          leftWidget: this.props.nullOptionLeftWidget
        });
      }

      return items;
    }
  }, {
    key: "getFilteredItems",
    value: function getFilteredItems(items) {
      var _this4 = this;

      if (this.shouldItemRender) {
        items = items.filter(function (item) {
          return _this4.shouldItemRender(item, _this4.state.displayText);
        });
      }

      return items;
    }
  }, {
    key: "autoCompleteText",
    value: function autoCompleteText() {
      if (this.state.displayText === '') return;
      var highlightedIndex = this.state.highlightedIndex;
      var itemList = this.getItemsWithPriorityList();
      var items = this._triggerClicked ? itemList : this.getFilteredItems(itemList);

      if (items.length === 0) {
        // No matches in dropdown
        this.setState({
          highlightedIndex: null
        });
        return;
      }

      var matchedItem = highlightedIndex !== null ? items[highlightedIndex] : items[0];
      var itemValue = matchedItem ? matchedItem.name : '';
      var itemValueDoesMatch = this.props.filterOnPartialMatch ? itemValue.toLowerCase().indexOf(this.state.displayText.toLowerCase() > -1) : itemValue.toLowerCase().indexOf(this.state.displayText.toLowerCase()) === 0;
      if (itemValueDoesMatch && highlightedIndex === null) this.setState({
        highlightedIndex: 0
      });
    }
  }, {
    key: "handleTriggerFieldClick",
    value: function handleTriggerFieldClick(event) {
      var cwDropdown = (0, _reactDom.findDOMNode)(this.cwDropdown);

      if (this.props.clickAreaToExpand) {
        if (cwDropdown) {
          if (!cwDropdown.contains(event.target)) {
            this.handleTriggerClick();
          }
        } else {
          this.handleTriggerClick();
        }
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.cwTriggerField.cwTextField.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var items = this.getItems();
      var priorityList = this.getPriorityList();
      var dropdownSettings = {
        top: this.state.menuTop,
        itemHeight: this.props.itemHeight ? this.props.itemHeight : (0, _CwThemeService.getMouseMode)() ? 24 : 32,
        inputHeight: this.state.inputHeight,
        maxItemsPerPage: 10,
        numOfItems: this.state.filter ? this.getFilteredItems(this.getItemsWithPriorityList()).length : items.length + priorityList.length,
        numOfExtraItems: this.props.pickerText ? 1 : 0
      };
      var dropdownPosition = (0, _CwDropdownService.calcDropdownPosition)(dropdownSettings);
      var style = {
        // Pass calculated position coordinates to dropdown with inline style
        left: this.state.menuLeft,
        top: dropdownPosition.top,
        minWidth: this.state.menuWidth,
        height: dropdownPosition.menuHeight
      };
      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId,
        className: _CwComboBox.default.comboBox,
        onClick: this.handleTriggerFieldClick
      }, _react.default.createElement(_CwTriggerField.default, {
        cwId: this.props.cwId + '_trigger',
        triggerIcon: this.props.triggerIcon,
        autoComplete: "off",
        ref: function ref(input) {
          return _this5.cwTriggerField = input;
        },
        onFocus: this.handleInputFocus,
        onBlur: this.handleInputBlur,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        value: this.state.displayText,
        disabled: this.props.disabled,
        invalid: this.props.invalid,
        readOnly: this.props.readOnly,
        onTrigger: this.handleTriggerClick,
        placeholder: this.props.placeholder,
        autoFocus: this.props.autoFocus,
        customElement: this.props.triggerCustomElement,
        className: this.props.triggerClassName,
        regex: this.props.regex
      }), this.state.expanded ? _react.default.createElement(_CwDropdown.default, {
        cwId: "".concat(this.props.cwId, "_dropdown"),
        items: this.state.filter ? this.getFilteredItems(items) : items,
        priorityList: this.state.filter ? this.getFilteredItems(priorityList) : priorityList,
        itemHeight: this.props.itemHeight,
        highlightedIndex: this.state.highlightedIndex,
        style: style,
        onClick: this.selectItemFromMouse,
        onMouseEnter: this.highlightItemFromMouse,
        onMouseDown: this.setIgnoreBlur // Ignore blur to prevent menu from de-rendering before we can process click
        ,
        filter: this.state.filter,
        pickerText: this.props.pickerText,
        ref: function ref(dropdown) {
          return _this5.cwDropdown = dropdown;
        }
      }) : null);
    }
  }]);
  return CwComboBox;
}(_react.default.Component);

CwComboBox.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Path to trigger icon
   */
  triggerIcon: _propTypes.default.string,

  /**
   * Array of items to be listed in the dropdown menu. Must contain at least "id" and "name" fields.
   */
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
    name: _propTypes.default.string,
    leftWidget: _propTypes.default.element
  })),

  /**
   * Represents the item that has been selected from the list (or string of custom item entered in if allowCustomEntry set to true). Returns an object {id,name} by default.
   */
  value: _propTypes.default.any,

  /**
   * Set to true if you want combobox to return just the id as the value instead of the object (i.e. for enums).
   */
  returnIdAsValue: _propTypes.default.bool,

  /**
   * Set to true if you want combobox to allow free text instead of only dropdown selection.
   */
  allowCustomEntry: _propTypes.default.bool,

  /**
   * Callback function that is fired when combobox's selection changes
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function that is fired when combobox's dropdown menu is expanded
   */
  onExpand: _propTypes.default.func,

  /**
   * Callback function that is fired when is key is pressed
   */
  onKeyDown: _propTypes.default.func,

  /**
   * Callback function that is fired when combobox's dropdown menu is collapsed
   */
  onCollapse: _propTypes.default.func,

  /**
   * Callback function that is fired when combobox's picker is clicked
   */
  onPicker: _propTypes.default.func,

  /**
   * Used to control if combobox is valid
   */
  invalid: _propTypes.default.bool,

  /**
   * Used to disable combobox
   */
  disabled: _propTypes.default.bool,

  /**
   * Text to display on combobox picker
   */
  pickerText: _propTypes.default.string,

  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes.default.func,

  /**
   * Used to set the inner text field to a read only mode
   */
  readOnly: _propTypes.default.bool,

  /**
   * Callback function that is fired when text is changed
   */
  textChange: _propTypes.default.func,

  /**
   * Filters on partial matches instead of exact matches
   */
  filterOnPartialMatch: _propTypes.default.bool,

  /**
   * Hint text, displayed when user has not typed anything in
   */
  placeholder: _propTypes.default.string,

  /**
   * Set true to add an option to the dropdown for null
   */
  hasNullOption: _propTypes.default.bool,

  /**
   * Determines what text will display in the dropdown for the null option
   */
  nullOptionName: _propTypes.default.string,

  /**
   * Used to add a custom element to the left side of the null option
   */
  nullOptionLeftWidget: _propTypes.default.any,

  /**
   * Used to control if input field is autofocused when the page loads
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Used to control if all text is highlighted on focus
   */
  selectAllOnFocus: _propTypes.default.bool,

  /**
   * Used to add custom css
   */
  className: _propTypes.default.string,

  /**
   * Used to add custom css to trigger field
   */
  triggerClassName: _propTypes.default.string,

  /**
   * Used to add a custom element to the left side of the trigger field
   */
  triggerCustomElement: _propTypes.default.any,

  /**
   * Used to override height on individual items in the drop down
   */
  itemHeight: _propTypes.default.number,

  /**
   * Used to allow blank 'names' for the value
   */
  allowEmptyName: _propTypes.default.bool,

  /**
   * Used to define a list of items that will show before the rest of the items in the dropdown
   * There could be a separator after the last item in this list
   */
  priorityList: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
    name: _propTypes.default.string,
    leftWidget: _propTypes.default.element
  })),

  /**
   * Used to decide whether to add a separator line after the priority list
   */
  addSeparatorAfterPriorityList: _propTypes.default.bool,

  /**
   * Used to allow Enter to select first item in list if no item is focused, instead of null
   */
  enterSelectsFirstItem: _propTypes.default.bool,

  /**
   * If true then re-render. Used to allow changing item name
   */
  customItemName: _propTypes.default.bool,

  /**
   * Used to limit the inputs of the field by matching against provided string.
   */
  regex: _propTypes.default.string,

  /**
   * If set to true, allows user to click anywhere in triggerField container to expand dropdown
   */
  clickAreaToExpand: _propTypes.default.bool
};
CwComboBox.defaultProps = {
  cwId: '',
  returnIdAsValue: false,
  allowCustomEntry: false,
  value: '',
  hasNullOption: false,
  nullOptionName: '',
  addSeparatorAfterPriorityList: false,
  priorityList: [],
  enterSelectsFirstItem: false,
  clickAreaToExpand: false
};
var _default = CwComboBox;
exports.default = _default;